<template>
	<aside id="sidebar-left" class="sidebar-left">
		<div class="mobile-menu-button-close">
			<font-awesome-icon  icon="fa-xmark" size="2xl" />
		</div>
		<div class="logo-container">	
			<span><img src="../assets/img/logo-logoright.svg"></span>
			<span class="collapse-expand-menu">
				<font-awesome-icon class="collapse-menu-icon" icon="fa-angle-left" size="lg" />
				<font-awesome-icon class="expand-menu-icon" icon="fa-angle-right" size="lg" />
			</span>						
		</div>		
		<div class="nano">
			<div class="nano-content">
				<nav id="menu" class="nav-main" role="navigation">
					<ul class="nav nav-main">
						<li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id">
							<a class="nav-link" @click="loginNow()">
								<span class="menu-icon-container" title="Вход в кабинет">
									<font-awesome-icon class="menu-icon admin-part" icon="fa-solid fa-user" size="lg" />
								</span>
								<span class="admin-part">Вход в кабинет</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id">
							<a class="nav-link" @click="logoutNow()">
								<span class="menu-icon-container" title="Выход в кабинета">
									<font-awesome-icon class="menu-icon admin-part" icon="fa-solid fa-arrow-right-from-bracket" size="lg" />
								</span>
								<span class="admin-part">Выход в кабинета</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="!loggedInUserData.user_id">
							<a class="nav-link" @click="signupNow()">
								<span class="menu-icon-container" title="Регистрация в системе">
									<font-awesome-icon class="menu-icon admin-part" icon="fa-solid fa-user-plus" size="lg" />
								</span>
								<span class="admin-part">Регистрация в системе</span>
							</a>
						</li>
						<li class="nav-parent nav-mobile" v-if="loggedInUserData.user_id">
							<a class="nav-link">
								<span class="menu-icon-container" title="">
									<font-awesome-icon v-if="loggedInUserData.admin_rights" class="menu-icon admin-part" icon="fa-solid fa-user" size="lg" />
									<font-awesome-icon v-else class="menu-icon admin-part" icon="fa-solid fa-hammer" size="lg" />
								</span>
								<span class="admin-part">{{loggedInUserData.first_name ? loggedInUserData.last_name + " " + loggedInUserData.first_name + " " + loggedInUserData.patronymic : loggedInUserData.company_title}}</span>
							</a>
						</li>
						<li class="nav-parent">&nbsp;</li>
						<li v-for="(firstLevel, firstIndex) in menu" :key="firstIndex"
							:class="{ 'nav-parent': firstLevel.child }">
							<router-link v-if="firstLevel.href && displayRow(firstLevel)" class="nav-link" :to="firstLevel.href">
								<span class="menu-icon-container" :title="firstLevel.title">
									<font-awesome-icon class="menu-icon" :class="{'admin-part': firstLevel.admin_rights}" :icon="firstLevel.icon" size="lg" />
								</span>
								<span :class="{'admin-part': firstLevel.admin_rights}">{{ firstLevel.title }} <span v-if="unread && firstLevel.href == '/user/notices'" class="blue-circle">{{ unread }}</span></span>
							</router-link>
							<a v-else-if="!firstLevel.href && displayRow(firstLevel)" class="nav-link" @click="firstLevel.expanded = !firstLevel.expanded">
								<span class="menu-icon-container" :title="firstLevel.title">
									<font-awesome-icon class="menu-icon" :icon="firstLevel.icon" size="lg" />
								</span>	
								<span>{{ firstLevel.title }}</span>
								<font-awesome-icon v-if="firstLevel.child && firstLevel.expanded" class="menu-arrow"
									icon="angle-up" size="lg" />
								<font-awesome-icon v-else-if="firstLevel.child && !firstLevel.expanded"
									class="menu-arrow" icon="angle-down" size="lg" />
							</a>
							<ul v-if="firstLevel.child" class="nav nav-children nav-children-1" :key="'c' + firstIndex">
								<li v-for="(secondLevel, secondIndex) in (firstLevel.lessons ? menuLessons : firstLevel.child)"
									:key="secondIndex" :class="{ 'nav-parent': secondLevel.child }">
									<router-link v-if="secondLevel.href && (displayRow(secondLevel) || loggedInUserData.mik_rights)" class="nav-link" :to="secondLevel.href">
										{{ secondLevel.number ? secondLevel.number + '. ' : '' }}{{ secondLevel.title }}
									</router-link>
									<a v-if="!secondLevel.href && (displayRow(secondLevel) || loggedInUserData.mik_rights)" class="nav-link" @click="secondLevel.expanded = !secondLevel.expanded">									
										{{ secondLevel.number ? secondLevel.number + '. ' : '' }}{{ secondLevel.title }}
										<font-awesome-icon v-if="secondLevel.expanded" class="menu-arrow"
											icon="angle-up" size="lg" />
										<font-awesome-icon v-else-if="!secondLevel.expanded" class="menu-arrow"
											icon="angle-down" size="lg" />
									</a>
									<ul v-if="secondLevel.child" class="nav nav-children nav-children-2">
										<li v-for="(thirdLevel, thirdIndex) in secondLevel.child" :key="thirdIndex">											
											<router-link :id="'nav-link-' + thirdLevel.lesson_id" class="nav-link" :to="thirdLevel.href">{{ thirdLevel.number ? thirdLevel.number + '. ' : '' }}{{ thirdLevel.title }}
											</router-link>
										</li>
									</ul>
								</li>								
							</ul>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</aside>
</template>

<script>
import axios from 'axios'
import $ from "jquery";

export default {

	name: 'SideBar',

	props: ["logout", "login"],

	watch: {
		logout: function(val){
			console.log("Logout in SideBar", val)
			this.loggedInUserData = []
		},
		login: function(val){
			console.log("Login in SideBar", val)
			this.loggedInUserData = JSON.parse(localStorage.getItem('app_user_data')) || false
		}
	},

	data() {
		return {
			loggedInUserData: JSON.parse(localStorage.getItem('app_user_data')) || false,
			appTitle: localStorage.getItem('app_title'),			
			menuLessons: [],
			unread: 0,
			menu: [
				{
					href: '/check',
					title: 'Проверка товарного знака',
					icon: 'fa-solid fa-spell-check',
					instructor_rights: false,
					mik_display: false,
					need_auth: false,
					only_user: false
				},			
				{
					href: '/calc',
					title: 'Калькулятор стоимости',
					icon: 'fa-solid fa-calculator',
					instructor_rights: false,
					mik_display: false,
					need_auth: false,
					only_user: false
				},
				{
					href: '/user/profile',
					title: 'Мой профиль',
					icon: 'fa-solid fa-user-gear',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/application/view',
					title: 'Мои заявки',
					icon: 'fa-solid fa-briefcase',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/application/create',
					title: 'Создать заявку',
					icon: 'fa-solid fa-square-plus',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/user/documents',
					title: 'Документы по заказам',
					icon: 'fa-solid fa-envelopes-bulk',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: true
				},
				{
					href: '/user/notices',
					title: 'Уведомления',
					icon: 'fa-solid fa-bell',
					instructor_rights: false,
					mik_display: false,
					need_auth: true,
					only_user: false
				},				
				{
					href: '/admin/applications',
					title: 'Админ — Заявки',
					icon: 'fa-solid fa-users-cog',
					instructor_rights: false,
					admin_rights: true,
					mik_display: false,
					need_auth: true,
					only_user: false
				},
				{
					href: '/admin/users',
					title: 'Админ — Пользователи',
					icon: 'fa-solid fa-users-cog',
					instructor_rights: false,
					admin_rights: true,
					mik_display: false,
					need_auth: true,
					only_user: false
				},
				// {
				// 	href: '/info',
				// 	title: 'Документация',
				// 	icon: 'fa-solid fa-book',
				// 	instructor_rights: false,
				// 	mik_display: false,
				// 	need_auth: false
				// },
				// {
				// 	href: '/contacts',
				// 	title: 'Контакты',
				// 	icon: 'fa-solid fa-circle-nodes',
				// 	instructor_rights: false,
				// 	mik_display: false,
				// 	need_auth: false
				// },				
			]
		}
	},

	created() {
				
	},

	mounted() {		

		// Анимация разворачивания списков меню до текущего пункта в случае перезагрузки приложения
		setTimeout(() => {
			$(".router-link-active").parents(".nav-children-1").slideToggle(500, function () {
				$(".router-link-active").parents(".nav-children-2").slideToggle(500);
			});
		}, 500);

		// Скорость раскрытия и закрытия бокового меню (мс)
		var collapseSpeed = localStorage.getItem('app_collapse_speed');

		// Запуск функции обновления информации о непрочитанных уведомлениях
		setTimeout(this.getUnreadNotices, 1000);

		// Метод закрытия меню
		function collapseMenu() {
			$(".sidebar-left").animate({
				width: [ "73px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".logo-container span:first-child").animate({
				width: [ "0px", "swing" ],
				opacity: [ "0", "swing" ]					
			}, collapseSpeed, "linear");
			$("a.nav-link span:nth-child(2), ul.nav-main li .nav-children li a, .menu-arrow").animate({	
				width: [ "0px", "swing" ],			
				opacity: [ "0", "swing" ]					
			}, collapseSpeed, "linear");
			$(".collapse-expand-menu").animate({
				width: [ "56px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".collapse-menu-icon").fadeOut(collapseSpeed / 2, function() {
				$(".expand-menu-icon").fadeIn(collapseSpeed / 2);				
			});
			$(".content-body").animate({
				marginLeft: [ "75px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".user-bar").animate({
				paddingLeft: [ "75px", "swing" ]					
			}, collapseSpeed, "linear", function() {
				$(".materials-slide-container").css("width", "calc(100% - 75px)");	
				$(".material-layer-blank").css("width", "calc(100% - 75px)");	
				$(".material-layer-blank").css("marginLeft", "75px");								
			});					
			$(".nav-parent > .nav-children:visible").each(function(){				
				$(this).siblings(".nav-link").trigger("click");		
			});
						
		}

		// Метод раскрытия меню
		function expandMenu() {
			$(".sidebar-left").animate({
				width: [ "350px", "swing" ]					
			}, collapseSpeed, "linear");					
			$(".logo-container span:first-child").animate({
				width: [ "200px", "swing" ],
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");
			$("a.nav-link span:nth-child(2)").animate({	
				width: [ "240px", "swing" ],			
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");
			$("ul.nav-main li .nav-children li a").animate({	
				width: [ "330px", "swing" ],			
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");					
			$(".menu-arrow").animate({
				width: [ "12px", "swing" ],
				opacity: [ "1", "swing" ]					
			}, collapseSpeed, "linear");					 
			$(".collapse-expand-menu").animate({
				width: [ "26px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".expand-menu-icon").fadeOut(collapseSpeed / 2, function() {
				$(".collapse-menu-icon").fadeIn(collapseSpeed / 2);				
			});
			$(".content-body").animate({
				marginLeft: [ "350px", "swing" ]					
			}, collapseSpeed, "linear");
			$(".user-bar").animate({
				paddingLeft: [ "350px", "swing" ]					
			}, collapseSpeed, "linear", function() {
				$(".materials-slide-container").css("width", "calc(100% - 350px)");	
				$(".material-layer-blank").css("width", "calc(100% - 350px)");	
				$(".material-layer-blank").css("marginLeft", "350px");							
			});
		}

		$(document).ready(() => {			
			
			$("#menu").delegate(".nav-link", "click", function(){
				console.log("Menu item .nav-link clicked.");
				$(this).parent(".nav-parent").find("ul:first").slideToggle(500);
			});

			if(window.innerWidth > 992){

				var menuCollapsed = localStorage.getItem('app_menu_collapsed') || 0;
				
				if(menuCollapsed == 1){
					$('.expand-menu-icon').css("display", "inline-block");
					collapseMenu();
				}else{
					$('.collapse-menu-icon').css("display", "inline-block");
					expandMenu();
				}

				$(".collapse-expand-menu").click(function(){
					menuCollapsed = localStorage.getItem('app_menu_collapsed') || 0;
					if(menuCollapsed == 1){
						expandMenu();
						localStorage.setItem('app_menu_collapsed', 0);
					}else{
						collapseMenu();
						localStorage.setItem('app_menu_collapsed', 1);
					}
				})

			}	

		});		

	},		

	methods: {
		
		getUnreadNotices() {
			
			axios({ url: `/notices?unread=1`, method: 'GET' })
				.then(response => {
					this.viewloading = false
					if (response.status == 200 && response.data && response.data.data) {
						this.unread = Number(response.data.total)
					}
				})
				.catch(error => {
					this.viewloading = false						
					if(error && error.response && error.response.data && error.response.data.message){
						//this.msg.value = "Ошибка при загрузке заявок"
						//this.msg.details = error.response.data.message
						//this.msg.type = 2
					}else{
						this.msg.value = "Ошибка при загрузке уведомлений"
						this.msg.details = error
						this.msg.type = 2
					}
					this.unread = 0					
				})				
			setTimeout(this.getUnreadNotices, 15000)	
		},
		
		logoutNow(){
			localStorage.removeItem('app_user_data')
			localStorage.removeItem('app_token')
			delete axios.defaults.headers.common['Authorization']
			this.loggedInUserData = []
			this.$emit('onLogout', true)
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}			
		},

		signupNow(){
			if(this.$router.currentRoute.path != "/signup"){
				this.$router.push("/signup")
			}
		},

		loginNow(){
			if(this.$router.currentRoute.path != "/login"){
				this.$router.push("/login")
			}
		},

		// Метод отображения пункта меню
		displayRow(item) {
			if(item.need_auth == true){
				if(this.loggedInUserData.user_id > 0){
					if(item.admin_rights){
						if(this.loggedInUserData.admin_rights){
							return true
						}else{
							return false
						}
					}else if(item.only_user){
						if(this.loggedInUserData.admin_rights){
							return false
						}else{
							return true
						}
					}else{
						return true
					}
				}else{
					return false
				}	
			}else{
				return true
			}										
		}		
	}
}
</script>

<style>

.collapse-expand-menu {
	/* background-color: #303640; */
	background-color: #1d2127;
	padding: 4px 7px 4px 7px;	
	cursor: pointer;
	position: absolute;
	top: 8px;
	right: 9px;
	text-align: center;
}

.collapse-expand-menu:hover {
	background-color: #000;
}	

.collapse-menu-icon,
.expand-menu-icon {
	color: #abb4be;
	display: none;	
}	

.instructor-command {
	width: 100%; 
	background-color: #ffdb29; 
	color: #333; 
	text-align: center;
	padding: 15px;
	margin-top: 1px;
}

.instructor-command input {
	background-color: #1D2127;
	margin-top: 10px;
}	

.instructor-command input:hover {
	background-color: #000;
}



</style>